module.exports = __webpack_public_path__ + "img/style_w_1.c2982a81.png";